import { ResultResponse } from './common'
import gql from 'graphql-tag'

export interface SendOpinionResponse {
  sendOpinion: ResultResponse
}

export interface SendOpinionVars {
  opinion: string
  path: string
  user_agent: string
}

export const SEND_OPINION = gql`
  mutation SendOpinion (
    $opinion: String!
    $path: String
    $user_agent: String
    $file_path: String
  ) {
    sendOpinion (
      opinion: $opinion
      path: $path
      user_agent: $user_agent
      file_path: $file_path
    ) {
      result
    }
  }
`